module.exports = __webpack_public_path__ + "static/ysdnBackgroundImage-a9d08a42e9c99a9178f5ef846e3a9b41.mp4";